import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const WorkExp = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M9.67 12.09H7.02a.74.74 0 0 0-.74.74v2.35c0 .409.331.74.74.74h2.65a.74.74 0 0 0 .74-.74v-2.35a.74.74 0 0 0-.74-.74Z" />
      <Path d="M18.01 5.2H16.8V3.79c0-.44-.36-.8-.8-.8-.44 0-.8.36-.8.8V5.2H8.8V3.79c0-.44-.36-.8-.8-.8-.44 0-.8.36-.8.8V5.2H6.01c-1.65 0-2.99 1.34-2.99 2.99v9.9c0 1.65 1.34 2.99 2.99 2.99h12c1.65 0 2.99-1.34 2.99-2.99v-9.9c0-1.65-1.34-2.99-2.99-2.99Zm1.39 12.89c0 .77-.62 1.39-1.39 1.39h-12c-.77 0-1.39-.62-1.39-1.39V10.8H19.4v7.29Zm0-8.89H4.62V8.19c0-.77.62-1.39 1.39-1.39h12c.77 0 1.39.62 1.39 1.39V9.2Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default WorkExp
